/**
 * Noms canoniques des fonctionnalités (entitlements). Source unique côté front, alignée sur le
 * registre back (`Entitlements:Features`). Ne JAMAIS coder une feature en dur ailleurs : référencer
 * ces constantes.
 */
export const FEATURES = {
  /** Fonctionnalités de base (abonnement classique / à vie). */
  SUCCESSION_CORE: 'succession_core',
  /** Agrégation bancaire « Mon Budget » (Linxo) — débloquée par l'option Premium. */
  LINXO_ACCESS: 'linxo_access',
} as const;

export type FeatureKey = (typeof FEATURES)[keyof typeof FEATURES];

/**
 * Feature ouvrant la « gestion professionnelle » (patrimoine pro, résumé/bilan pro, documents
 * confidentiels d'entreprise à transmettre). Aujourd'hui portée par l'option Premium
 * (`linxo_access`) — miroir exact du back `Authorization.ProfessionalAccess.Feature`. Pour basculer
 * vers une feature dédiée, ne changer QUE cette constante (et le back en regard).
 */
export const PROFESSIONAL_ACCESS_FEATURE: FeatureKey = FEATURES.LINXO_ACCESS;
